import { MapPin, Mail, Phone, Clock } from "lucide-react";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";
import ContactForm from "@/components/ContactForm";
import { Reveal } from "@/components/motion";
import { BRAND } from "@/data/site";

const INFO = [
  { icon: MapPin, label: "Locations", value: BRAND.locations.join(" · ") },
  { icon: Mail, label: "Email", value: BRAND.email, href: `mailto:${BRAND.email}` },
  { icon: Phone, label: "Phone", value: BRAND.phone, href: `tel:${BRAND.phone}` },
  // { icon: Clock, label: "Business Hours", value: BRAND.hours },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <Seo
        title="Contact Us"
        description="Book a free 30-minute discovery call with North Cadence's senior leadership. No pitch, no pressure — just the right next step for your career or organisation."
      />
      <PageHero
        eyebrow="Contact Us"
        title={["Let's start a", "conversation."]}
        subtitle="Book a free 30-minute discovery call with our senior leadership — no pitch, no pressure. Tell us about your goals and we'll recommend the right starting point."
      />

      <section className="bg-white py-8">
        <div className="nc-container grid gap-12 lg:grid-cols-[0.85fr_1.15fr]">
          {/* Left info */}
          <div>
            <div className="space-y-5">
              {INFO.map((item) => (
                <Reveal key={item.label}>
                  <div className="flex items-start gap-4 rounded-2xl border border-[#e7e9ef] bg-[#FEF7F2] p-5">
                    <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#142A5E]/8 text-[#142A5E]">
                      <item.icon className="h-5 w-5" />
                    </span>
                    <div>
                      <p className="text-sm font-semibold uppercase tracking-wider text-[#1B1B1B]/45">{item.label}</p>
                      {item.href ? (
                        <a href={item.href} className="mt-1 block font-medium text-[#1B1B1B] hover:text-[#142A5E]">{item.value}</a>
                      ) : (
                        <p className="mt-1 font-medium text-[#1B1B1B]">{item.value}</p>
                      )}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            {/* <Reveal delay={0.1}>
              <div className="mt-6 overflow-hidden rounded-2xl border border-[#e7e9ef]">
                <iframe
                  title="North Cadence location"
                  src={BRAND.mapEmbed}
                  className="h-64 w-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal> */}
          </div>

          {/* Right form */}
          <Reveal delay={0.05}>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
